export default __webpack_public_path__ + "static/media/SAL4.eeaaafe7.jpg";